import React, { useState, useEffect, useRef } from 'react';
import { Modal, message, Empty, Card, Typography, Collapse, Divider, Row, Col, Spin, Popover, Pagination, Skeleton, Drawer, Space } from 'antd';
import moment from 'moment';
import 'moment-timezone';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import MailDetailView from '../Email/MailDetailView';
import { FetchRelatedEmails, FetchRelatedEmails1, FetchDetailspage, findOneByMailService, removeMailFromAstraDB, getEmailSummary, deleteEmailActivity } from '../../../Api/Services/EmailApiSevices'
import { FetchAllLead, FetchAllLeadByDep } from '../../../Api/Services/LeadApiServices'
import { FetchAllContact, FetchAllContactByDep } from '../../../Api/Services/ContactApiService'
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
import { PaperPlaneSendIcon, PaperPlaneReciveIcon, CancelIcon, AiDbIcon } from '../../../components/Icons/Icons';
import { Button } from '../../../components/buttons/buttons';
import CustomHtmlParser from '../Email/CustomHtmlParser'

const { Text } = Typography;
const { Panel } = Collapse;
const EmailTable = ({ UrlId, NacTrigger, refreshTrigger, tabKey, setNaCTrigger, profile, emailactiontype }) => {
    const PAGE_SIZE = 20;
    const isClickingRef = useRef(false);
    const skipOnChangeRef = useRef(false);
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const VectorDb = localData.vectorDb
    const combinedUrl = urlPathname + urlSearch;
    const [allMails, setAllMails] = useState()
    const [emailPopup, setEmailPopup] = useState(false)
    const [emailUnlink, setEmailUnlink] = useState(false)
    const [popupType, setPopupType] = useState()
    const [emailOpenId, setEmailOpenId] = useState()
    const [allattendeeData, setAllattendeeData] = useState()
    const [emailActivityId, setEmailActivityId] = useState()
    const [openPage, setOpenPage] = useState(Array(allMails?.length).fill(false));
    const [panelData, setPanelData] = useState();
    const [openPanels, setOpenPanels] = useState([]);
    const [allLeadList, setAllLeadList] = useState();
    const [allContactList, setAllContactList] = useState();
    const [symmaruData, setSymmaruData] = useState()
    const [loadingPage, setLoadingPage] = useState(false);
    const [loadingPage1, setLoadingPage1] = useState(false);
    const [apiPage, setApiPage] = useState();
    const [activeKey, setActiveKey] = useState()
    const [tablePage, setTablePage] = useState();
    const [totalCount, setTotalCount] = useState([])
    const [apiType, setApiType] = useState()
    const mergeUniqueById = (existing = [], incoming = [], idKey = 'mailServiceId') => {
        const seen = new Set(existing.map(item => item[idKey]));
        return [...existing, ...incoming.filter(item => !seen.has(item[idKey]))];
    };
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    function normalizeEmailData(input) {
        const BodywithLinks = (data) => {
            const urlPattern = /(https?:\/\/[^\s]+)/g;
            const formattedMessage = data.replace(urlPattern, (url) => {
                const escapedUrl = encodeURIComponent(url);
                return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
            });
            return formattedMessage.replace(/\n/g, '<br />');
        };
        let bodyText = "";
        if (emailactiontype?.emailType === "Outlook") {
            bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
        }
        else if (emailactiontype?.emailType === "Google" || emailactiontype?.emailType === "Zoho" || emailactiontype?.emailType === "Other Email") {
            bodyText = input ? (input?.htmlContent && input?.htmlContent !== "") ? input.htmlContent : input?.textContent ? BodywithLinks(input.textContent) : "" : ""
        }
        return {
            body: bodyText,
        };
    }
    function normalizeEmailDataforOutlook(input) {
        let bodyText = "";
        if (emailactiontype?.emailType === "Outlook") {
            bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
        }
        return {
            body: bodyText,
        };
    }
    const handleCollapseChange = async (keys) => {
        const newOpenPanels = keys.map(Number);
        const added = newOpenPanels.find((key) => !openPanels.includes(key));
        if (added !== undefined) {
            if (!panelData[added]?.body) {
                const mailid = allMails[added]
                if (profile?.userId === mailid.linkedBy) {
                    if (mailid.mailServer === emailactiontype?.emailType) {
                        try {
                            const Response = await FetchDetailspage(mailid.sourceId, mailid.actionType === "Recived" ? "INBOX" : mailid.actionType === "Sent" ? "Sent" : "")
                            let modifiedData;
                            const originalData = Response.data;
                            if (emailactiontype?.emailType === 'Outlook') {
                                modifiedData = normalizeEmailDataforOutlook(originalData)
                            } else if (emailactiontype?.emailType === 'Google' || emailactiontype?.emailType === 'Zoho' || emailactiontype?.emailType === "Other Email") {
                                modifiedData = normalizeEmailData(originalData);
                            };
                            const updatedPanelData = [...panelData];
                            updatedPanelData[added] = { ...updatedPanelData[added], body: modifiedData.body };
                            setPanelData(updatedPanelData);
                        }
                        catch (error) {
                            message.error(error)
                        }
                    }
                    else {
                        message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
                    }
                }
                else {
                    message.info("Email details not found. Please contact your admin for details")
                }
            }
        }
        setOpenPanels(newOpenPanels);
    };
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    const emailClose = () => {
        setEmailPopup(false)
        setPopupType()
        setEmailOpenId()
        setNaCTrigger("CallBack")
    }
    const emailCloseUnlink = () => {
        setEmailUnlink(false)
        setEmailActivityId()
    }
    const ViewDetailPage = (id, type, userId, server) => {
        if (profile?.userId === userId) {
            if (server === emailactiontype?.emailType) {
                setEmailPopup(true)
                setPopupType(type)
                setEmailOpenId(id)
                setNaCTrigger("trigger")
            }
            else {
                message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
            }
        }
        else {
            message.info("Email details not found. Please contact your admin for details")
        }
    }
    async function CreatorLedadListApi() {
        try {
            let Lead;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                Lead = await FetchAllLeadByDep()
            }
            else {
                Lead = await FetchAllLead()
            }
            setAllLeadList(Lead)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function CreatorcontactListApi() {
        try {
            let contact;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                contact = await FetchAllContactByDep()
            }
            else {
                contact = await FetchAllContact()
            }
            setAllContactList(contact)
        }
        catch (error) {
            message.error(error)
        }
    }
    function getOrganizerFrom(id, type, dataList) { // address
        const filtered = dataList.filter(item => item.type === type);
        return filtered.find(item => item.id === id) || { name: "Not Available", email: "Not Available" };
    }
    function getOrganizerFromEmail(email, type, dataList) {
        const filtered = dataList.filter(item => item.type === type);
        return filtered.find(item => item.email === email) || { name: "Not Available", email: "Not Available" };
    }
    const getattendeeFrom = (type, fromEmail, dataList) => {
        const users = dataList.filter(item => item.type === type);
        const user = users.find(u => u.email === fromEmail);
        const name = user?.name?.trim();
        // const validData = name || fromEmail;
        const validData = name || "Not Available";
        return validData
    };
    function formatAttendees(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(att => att.address !== hostEmail && att.email !== hostEmail);
        filteredAttendees.forEach(att => {
            const email = att.address || att.email;
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                apiUser => apiUser.email === email
            );

            if (apiMatch && !includedEmails.has(email)) {
                attendeeData.push(apiMatch);
                includedEmails.add(email);
            }
        });
        if (configEmail && configEmail !== hostEmail && !includedEmails.has(configEmail) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail,
                email: configEmail,
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function findDataByEmail(email, leadData = [], contactData = []) {
        const leadMatchfound = leadData.find(item => item.primary_email === email);
        if (leadMatchfound) {
            return {
                name: `${leadMatchfound?.first_name} ${leadMatchfound?.last_name}`,
                email: leadMatchfound?.primary_email,
            };
        }
        const contactMatchfound = contactData.find(item => item.email === email);
        if (contactMatchfound) {
            return {
                name: `${contactMatchfound?.first_name} ${contactMatchfound?.last_name}`,
                email: contactMatchfound?.email,
            };
        }
        return {
            name: "Not Available",
            email: "Not Available"
        };
    }
    async function mailServerEmailData(mailServiceId) {
        const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
        const parseEmail = (emailString) => {
            emailString = cleanString(emailString);
            const match = emailString.match(/(.*)<(.+)>/);
            if (match) {
                return {
                    name: cleanString(match[1]),
                    address: match[2].trim(),
                };
            }
            return {
                name: "",
                address: emailString,
            };
        };
        const normalizeField = (field) => {
            if (!field) return [];
            return field.split(",").map((item) => parseEmail(item.trim()));
            // return field.split(/[;,]/).map((item) => parseEmail(item.trim()));
        };
        try {
            const MailServerResponse = await findOneByMailService(mailServiceId)
            const formattedFrom = parseEmail(MailServerResponse?.from || "");
            const formattedTo = normalizeField(MailServerResponse?.to || "");
            return {
                fromData: formattedFrom,
                toData: formattedTo,
            };
        } catch (error) {
            message.error(error)
            const formattedFrom = parseEmail("");
            const formattedTo = normalizeField("");
            return {
                fromData: formattedFrom,
                toData: formattedTo,
            };
        }
    }
    async function RecentActivity2() {
        try {
            const data = await FetchRelatedEmails1(UrlId[1], apiType);
            setTotalCount(data)
        } catch (error) {
            message.error(error);
        }
    }
    async function AllEmails(page) {
        try {
            setLoadingPage(true);
            const data = await FetchRelatedEmails(UrlId[1], apiType, page);
            const AllData = data?.filter(item => item.sourceType === "Mail")
            const FormatedData = await Promise.all(AllData?.map(async (email) => {
                const { entityId, entityType, actionType, mailServiceId } = email;
                const { fromData, toData } = await mailServerEmailData(mailServiceId)
                let FromData;
                if (actionType === "Sent") {
                    FromData = emailactiontype?.email === fromData?.address ?
                        `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom("User", fromData?.address, allattendeeData)
                }
                if (actionType === "Recived") {
                    if (entityType === "Lead" || entityType === "Contact") {
                        const origanizerdata = getOrganizerFrom(entityId, `${entityType}s`, allattendeeData, fromData?.address)
                        FromData = origanizerdata?.name || origanizerdata?.email
                    }
                    else if (entityType === "Case") {
                        const origanizerdata = findDataByEmail(fromData?.address, allLeadList, allContactList)
                        FromData = origanizerdata?.name || origanizerdata?.email
                    }
                    else {
                        const origanizerdata = getOrganizerFromEmail(fromData?.address, "Contacts", allattendeeData)
                        FromData = origanizerdata?.name || origanizerdata?.email
                    }
                }
                const ToData = formatAttendees(toData, fromData?.address, emailactiontype?.email, allattendeeData, email.linkedBy);
                return {
                    ...email,
                    FromData,
                    ToData,
                }
            }));
            if (page === 1) {
                setAllMails(FormatedData);
                setPanelData(FormatedData.map(() => ({ body: null })));
            } else {
                setAllMails((prev) => {
                    const merged = mergeUniqueById(prev, FormatedData);
                    setPanelData((prevPanel) => [
                        ...prevPanel,
                        ...FormatedData.map(() => ({ body: null }))
                    ]);
                    return merged;
                });
            }
            setLoadingPage(false);
        } catch (error) {
            setLoadingPage(false);
            message.error(error);
        }
    }
    async function GetMailSummary() {
        const payload = {
            "companyId": companyProfile.companyId,
            "entityType": apiType,
            "entityId": Number(UrlId[1])
        }
        try {
            setLoadingPage1(true);
            const data = await getEmailSummary(payload);
            setSymmaruData(data.data)
            setLoadingPage1(false);
        } catch (error) {
            setLoadingPage1(false);
            message.error(error);
        }
    }
    const handleCollapseChange1 = async (keys) => {
        setActiveKey(keys)
        if (keys.length && !loadingPage1) {
            GetMailSummary()
        }
    };
    const formatDateTimeData = (CreateDate) => {
        const createdTime = new Date(CreateDate);
        const tzString = profile?.timeZone || "(GMT+0:00) UTC";
        const tz = extractTimeZoneName(tzString);
        const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
        const currentTime = new Date(currentrealTime)
        const timeDifference = Math.floor((currentTime - createdTime) / (1000 * 60));
        const days = Math.floor(timeDifference / 1440);
        const formattedDate = createdTime.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric"
        });
        return days < 1 ? "Today" : formattedDate;
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });
        const timezoneCorrectedDate = new Date(formattedDate);
        const year = timezoneCorrectedDate.getFullYear();
        const month = String(timezoneCorrectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(timezoneCorrectedDate.getDate()).padStart(2, '0');
        const hours = String(timezoneCorrectedDate.getHours()).padStart(2, '0');
        const minutes = String(timezoneCorrectedDate.getMinutes()).padStart(2, '0');
        const formattedCustom = `${year}-${month}-${day} ${hours}:${minutes}`;
        return formattedCustom;
    };
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    const getPerosnnDetails = (fromEmail, dataList) => {
        const user = dataList.find(u => u.email === fromEmail);
        const name = user?.name?.trim();
        const validData = name || fromEmail;
        return validData
    };
    const timeadnDate = (dateTime) => {
        const [date, time] = dateTime.split(" ");
        // const formattedDate = profile?.dateFormate ? moment(date).format(profile.dateFormate) : moment(date).format("YYYY-MM-DD");
        const formattedDate = date;
        const formattedTime = convertTime(moment(time, "HH:mm:ss").format("HH:mm:ss"), profile.timeFormat ? profile.timeFormat : "24hrs");
        return { date: formattedDate, time: formattedTime };
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = "YYYY-MM-DD";
        const timeFormat = "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    async function UserDetailsApi() {
        try {
            const data = await FetchAllAttendeeList()
            setAllattendeeData(data)
        }
        catch (error) {
            setAllattendeeData([])
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            CreatorLedadListApi(),
            CreatorcontactListApi(),
        ])
    };
    const reFetchData = async () => {
        await Promise.allSettled([
            setApiPage(1),
            setTablePage(1),
            AllEmails(1),
            RecentActivity2()
        ])
    }
    useEffect(() => {
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
            setApiType("Lead")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
            setApiType("Deal")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
            setApiType("Contact")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
            setApiType("Account")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE") {
            setApiType("Case")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?FCASE") {
            setApiType("Case")
        }
        fetchAll()
    }, [])
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (allattendeeData && allLeadList && allContactList) {
                if (NacTrigger !== "trigger") {
                    reFetchData()
                }
            }
        }
    }, [UrlId, apiType, NacTrigger, allattendeeData, allLeadList, allContactList, refreshTrigger, tabKey])
    const UnLinkApi = (id) => {
        setEmailUnlink(true)
        setEmailActivityId(id)
    }
    const GetCallback = async (id) => {
        try {
            const response = await deleteEmailActivity(id)
            if (response.status === 200) {
                setEmailActivityId()
                setEmailUnlink(false)
                message.success("Email unliked")
                reFetchData()
            }
        }
        catch (error) {
            message.log(error)
        }
    }
    const [expandedItems, setExpandedItems] = useState({});
    const toggleExpand = (key) => {
        setExpandedItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    const openRagIng = async (id, data) => {
        try {
            const payload = {};
            const response = await removeMailFromAstraDB(payload, id, data);
            if (response?.status === 200) {
                message.success("Updated Successfully!");
                reFetchData()
            }
        } catch (err) {
            message.error(err);
        }
    };
    const handleTableChange = async (page) => {
        if (skipOnChangeRef.current) {
            skipOnChangeRef.current = false;
            return;
        }
        const newTablePage = page;
        if (newTablePage === tablePage) {
            return;
        }
        setTablePage(newTablePage);
        const maxIndexNeeded = newTablePage * PAGE_SIZE;
        if (allMails.length < maxIndexNeeded) {
            skipOnChangeRef.current = false;
            const nextApiPage = apiPage + 1;
            AllEmails(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            setApiPage(newTablePage);
        }
    };
    const handleTableChange2 = async (pagination, navigationType) => {
        skipOnChangeRef.current = true;
        if (isClickingRef.current) return;
        setTablePage(pagination);
        const maxIndexNeeded = pagination * PAGE_SIZE;
        if (allMails.length < maxIndexNeeded) {
            isClickingRef.current = true;
            const nextApiPage = apiPage + 1;
            AllEmails(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            const nextApiPage = navigationType === "prev" ? apiPage - 1 : apiPage + 1
            setApiPage(nextApiPage);
        }
        skipOnChangeRef.current = false;
    };
    const sortedActivities = allMails
        ?.sort((a, b) => {
            const dateA = a.actionDate ? moment(convertAndFormatDateTime(a.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
            const dateB = b.actionDate ? moment(convertAndFormatDateTime(b.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
            if (!dateA || !dateB) return 0;
            return dateB - dateA;
        });
    const paginatedActivities = sortedActivities?.slice(
        (tablePage - 1) * PAGE_SIZE,
        tablePage * PAGE_SIZE) || [];
    useEffect(() => {
        if (isClickingRef.current && allMails) {
            isClickingRef.current = false;
        }
    }, [allMails]);
    return (
        <>
            {loadingPage ?
                <div className="spin">
                    <Spin />
                </div>
                :
                <>
                    {paginatedActivities?.length > 0 ?
                        <>
                            {apiType !== "Case" ? <div style={{ marginBottom: 15 }}>
                                <Card className="DetailsTabCard">
                                    <Collapse bordered={false} className="DetailsTabCollapse" activeKey={activeKey?.[0]} onChange={handleCollapseChange1}>
                                        <Panel
                                            header={
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <Text strong style={{ marginRight: 5 }} title="Recent Emails Summary"> Recent Emails Summary</Text>
                                                </div>
                                            }
                                            extra={
                                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    {/* Last Updated Date */}
                                                    {/* <div style={{ display: "flex", alignItems: "center" }}>
                                                    <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}, {action.time}
                                                </div> */}
                                                </div>
                                            }
                                        >
                                            <Divider style={{ margin: 0 }} />
                                            <div style={{ marginTop: 10 }}>
                                                {loadingPage1 ?
                                                    (
                                                        <Skeleton title={false} active paragraph={{ rows: 7 }} />
                                                    ) : (
                                                        <Text type="secondary">
                                                            {symmaruData && symmaruData !== "" ? <CustomHtmlParser html={symmaruData} key={1} page="Previewss" /> : "No Body"}</Text>
                                                    )}
                                            </div>
                                        </Panel>
                                    </Collapse>
                                </Card>
                            </div> : <></>}
                            <div>
                                {paginatedActivities?.map((item, index) => {
                                    const convertsDate = item.actionDate ? convertAndFormatDateTime(item.actionDate, companyProfile, profile) : item.actionDate;
                                    const CorrectActionDate = formatDate(convertsDate)
                                    const action = convertsDate ? timeadnDate(CorrectActionDate) : { date: "", time: "" };
                                    const formattedTimeDifference = action.date && action.date !== "" ? formatDateTimeData(action.date) : ""
                                    const emailPerson = emailactiontype?.email === item.fromEmail ? `${profile?.firstName} ${profile?.lastName}` : getPerosnnDetails(item.fromEmail, allattendeeData)
                                    return (
                                        <div key={index} style={{ marginBottom: 15 }}>
                                            <Card className="DetailsTabCard">
                                                <Collapse bordered={false} className="DetailsTabCollapse" activeKey={openPanels.map(String)} // Keep panels open
                                                    onChange={handleCollapseChange}>
                                                    <Panel
                                                        header={
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                {item.actionType === "Sent" ? <PaperPlaneSendIcon height={16} width={16} marginRight={5} /> :
                                                                    item.actionType === "Recived" ? <PaperPlaneReciveIcon height={16} width={16} marginRight={5} /> : ""}

                                                                <Text strong style={{ marginRight: 5 }} title={item?.subject !== "" ? item.subject : "(No Subject)"}>
                                                                    {item?.subject ? item?.subject.length > 30 ? `${item.subject.slice(0, 30)}...` : item.subject : "(No Subject)"}</Text>
                                                                {/* <span style={{ color: "#adb4d2" }}>|</span> <span style={{ color: "#adb4d2", fontSize: 12 }}>{item.actionType === "Sent" ? item.fromEmail :  item.actionType === "Recived" ? item.to : ""}</span> */}
                                                                <span style={{ color: "#adb4d2", marginRight: 3 }}>|</span> <span style={{ color: "#adb4d2", fontSize: 12, marginTop: "0.2rem" }}>{emailPerson}</span>
                                                            </div>
                                                        }
                                                        key={String(index)}
                                                        extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}, {action.time}
                                                            </div>
                                                            <Popover
                                                                placement="bottom"
                                                                content={<>
                                                                    <div role="button" className="TableMore-Action" tabIndex="0" style={{ marginBottom: 5 }} onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                        <Link to={combinedUrl} className="text_icon" onClick={() => { ViewDetailPage(item.sourceId, item.actionType === "Recived" ? "INBOX" : item.actionType === "Sent" ? "Sent" : "", item.linkedBy, item.mailServer); handleOpenPageChange(index) }}>
                                                                            <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                        </Link>
                                                                    </div>
                                                                    <div role="button" className="TableMore-Action" tabIndex="0" style={{ marginBottom: (VectorDb?.isMail && profile.mailInjectionRequired === "Yes") ? 5 : 0 }} onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                        <Link to={combinedUrl} className="text_icon" onClick={() => { UnLinkApi(item.emailActivityId); handleOpenPageChange(index) }}>
                                                                            <FeatherIcon icon="link-2" size={16} style={{ marginRight: 5 }} /> Unlink
                                                                        </Link>
                                                                    </div>
                                                                    {(VectorDb?.isMail && profile.mailInjectionRequired === "Yes") ? <div role="button" className="TableMore-Action" tabIndex="0" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                        <Link to={combinedUrl} className="text_icon" onClick={() => { openRagIng(item.emailActivityId, item.mailInjectionRequired === "No" ? "Yes" : "No"); handleOpenPageChange(index) }}>
                                                                            <AiDbIcon height='16' width='16' marginRight={5} /> {item.mailInjectionRequired === "No" ? "Remove from vector store" : "Add to vector store"}
                                                                        </Link>
                                                                    </div> : <></>}
                                                                </>
                                                                }
                                                                trigger="hover"
                                                                open={openPage[index]}
                                                                onOpenChange={() => handleOpenPageChange(index)}
                                                            >
                                                                <div role="button" style={{ display: "flex", alignItems: "center" }} tabIndex="0" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                    <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                                </div>
                                                            </Popover>
                                                        </div>}
                                                    >
                                                        <Divider style={{ margin: 0 }} />
                                                        <div style={{ marginTop: 10 }}>
                                                            {panelData && panelData[index]?.body ? (
                                                                <Text type="secondary">
                                                                    {panelData[index].body && panelData[index].body !== "" ? <CustomHtmlParser html={panelData[index].body} key={index} page="Previewss" /> : "No Body"}</Text>
                                                            ) : (
                                                                <Skeleton title={false} active />
                                                            )}
                                                        </div>

                                                        <Row gutter={16} style={{
                                                            marginTop: 10,
                                                            borderRadius: 15,
                                                            border: "1px solid #dddddd"
                                                        }}>
                                                            <Col span={12} style={{ borderRight: "1px solid #dddddd", padding: "5px 10px" }}>
                                                                <Text type="secondary" className='RightSide-Lable'>From</Text>
                                                                <br />
                                                                <div className='div-ellipsis' title={item.FromData}>{item.FromData}</div>
                                                            </Col>
                                                            <Col span={12} style={{ padding: "5px 10px" }}>
                                                                <Text type="secondary" className='RightSide-Lable'>To  <InfoCircleOutlined title='The list below shows CRM users who were copied in the email. To view the full list of recipients, please click ‘View Details’' />
                                                                    {/* {item.actionType === "Recived" ? <InfoCircleOutlined style={{ fontSize: "small", color: '#0000009c', cursor: 'pointer', margin: "0px" }}
                                                    title={
                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE" ?
                                                            "The details below reflect only the case assignee at the time the email was received. To view all recipients, click 'View Details'" :
                                                            `The details below reflect only the ${UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" ? "lead" :
                                                                UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ? "contact" :
                                                                    UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" ? 'contact' :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT" ? 'contact' : ''} owner at the time the email was received. To view all recipients, click 'View Details'`}
                                                /> : ""} */}
                                                                </Text>
                                                                <br />
                                                                {item.ToData?.length > 0 ? (
                                                                    <>
                                                                        {(expandedItems[index] ? item.ToData : item.ToData.slice(0, 3)).map((attendee, i) => (
                                                                            <div className='div-ellipsis' key={i} title={attendee.name?.trim() || attendee.email}>
                                                                                {attendee.name?.trim() || attendee.email}
                                                                            </div>
                                                                        ))}

                                                                        {item.ToData.length > 3 && !expandedItems[index] && (
                                                                            <span
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                style={{ color: "#1890ff", cursor: "pointer" }}
                                                                                onClick={() => toggleExpand(index)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                                        toggleExpand(index);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                ...more
                                                                            </span>
                                                                        )}

                                                                        {item.ToData.length > 3 && expandedItems[index] && (
                                                                            <span
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                style={{ color: "#1890ff", cursor: "pointer" }}
                                                                                onClick={() => toggleExpand(index)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                                        toggleExpand(index);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                show less
                                                                            </span>
                                                                        )}
                                                                    </>
                                                                ) : "Not Available"}
                                                            </Col>
                                                        </Row>
                                                    </Panel>
                                                </Collapse>
                                            </Card>
                                        </div>
                                    )
                                })}
                                <div style={{ textAlign: "center", marginBottom: 10 }}>
                                    <Pagination
                                        current={tablePage}
                                        pageSize={PAGE_SIZE}
                                        total={allMails.length}
                                        onChange={handleTableChange}
                                        showSizeChanger={false}
                                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${totalCount.length} items`}
                                        itemRender={(page, type, originalElement) => {
                                            if (type === 'prev') {
                                                const isDisabled = tablePage <= 1;
                                                return (
                                                    <span role="button"
                                                        tabIndex={0}
                                                        className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                        style={{
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            opacity: isDisabled ? 0.4 : 1,
                                                            display: 'inline-flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                                if (!isDisabled) handleTableChange2(tablePage - 1, "prev")
                                                            }
                                                        }}
                                                        onClick={(e) => {
                                                            if (!isDisabled) handleTableChange2(tablePage - 1, "prev");
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <FeatherIcon icon="chevron-left" size={16} style={{ marginTop: 5 }} />
                                                    </span>
                                                );
                                            }

                                            if (type === 'next') {
                                                const isDisabled = (tablePage * PAGE_SIZE) >= totalCount.length || isClickingRef.current;
                                                return (
                                                    <span role="button"
                                                        tabIndex={0}
                                                        className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                        style={{
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            opacity: isDisabled ? 0.4 : 1,
                                                            display: 'inline-flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                                if (!isDisabled) handleTableChange2(tablePage + 1, "next")
                                                            }
                                                        }}
                                                        onClick={(e) => {
                                                            if (!isDisabled) handleTableChange2(tablePage + 1, "next");
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <FeatherIcon icon="chevron-right" size={16} style={{ marginTop: 5 }} />
                                                    </span>
                                                );
                                            }

                                            return originalElement; // normal page numbers
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                        :
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div>}
                </>
            }
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Email Message"
                open={emailPopup}
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => emailClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    emailClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                width="70%">
                <MailDetailView detailsId={emailOpenId} detailsPage={popupType} Comefrom="Entity" setNaCTrigger={setNaCTrigger} />
            </Drawer>
            {emailUnlink && <Modal
                title="Unlink Confirmation"
                open={emailUnlink}
                onCancel={emailCloseUnlink}
                footer={[<div>
                    <Button htmlType="submit" size="small" className="gray-button" onClick={() => emailCloseUnlink()}>
                        <FeatherIcon icon="x" /> No
                    </Button>
                    <Button htmlType="submit" size="small" onClick={() => GetCallback(emailActivityId)} className='button_colors'>
                        <FeatherIcon icon="check" /> Yes
                    </Button>
                </div>
                ]}
            >
                Are you sure you want to unlink this email from the deal?
            </Modal>
            }
        </>
    );
}
EmailTable.propTypes = {
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    emailactiontype: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(EmailTable)